import React from 'react'
import { useStyles } from './styles'

type HardwareGiveawayProps = {
  heading: string
  description: string | React.ReactNode
  img: string
  headingStyles?: React.CSSProperties
} & React.CSSProperties

export const HardWareGiveaway = (props: HardwareGiveawayProps) => {
  const { heading, description, img, headingStyles, ...styles } = props
  const { classes } = useStyles()
  return (
    <>
      <div className={classes.container} style={styles}>
        <img src={img} alt="" className={classes.img} />
        <div className={classes.textWrapper}>
          <span className={classes.title} style={headingStyles}>
            {heading}
          </span>
          {description && <span className={classes.subTitle}>{description}</span>}
        </div>
      </div>
    </>
  )
}
